import { Component, EventEmitter, Input, model, OnInit, Output, ViewChild } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { LocationsHttpService } from "../../services/locations-http.service";
import { CircuitListService, TrackLayoutAction } from "../../services/circuit-list/circuit-list.service";
import { ToastService, ToastType } from "src/app/shared/service/toast.service";
import { AppConstants } from "src/app/shared/constants/constants";
import { LOCATIONS_CONSTANTS } from "../../interfaces/locations-constants";
import { CircuitsServicesService } from "../../services/circuits-services.service";
import { firstValueFrom } from "rxjs";
import { DataServiceService } from "src/app/modules/events/services/data-service.service";

@Component({
  selector: "app-trackupload",
  templateUrl: "./trackupload.component.html",
  styleUrls: ["./trackupload.component.scss"]
})
export class TrackuploadComponent {
  translationData: any;
  trackType: string = 'offroad-trail';
  hideHeadersConditionally: boolean = true;
  uploadedFrom: any;
  constructor(
    private locationsHttpService: LocationsHttpService,
    private router: Router,
    private circuitListService: CircuitListService,
    private toastService: ToastService,
    private _circuitService: CircuitsServicesService,
    private _actRoute: ActivatedRoute,
    private dataService: DataServiceService
  ) { }
  @ViewChild("fileField") fileField: any;
  progress: number = 0;
  eventTotal: number = 100;
  showProgress = false;
  showSuccessDailog = false;
  progressTimeInterval: number = 100;
  @Output() closeModal = new EventEmitter<any>();
  @Output() openTrackModal = new EventEmitter<any>();
  @Input() public isShowModal: boolean = false;
  @Input() public page: any;
  @Input() public heading: string = 'Add a new layout';
  trackDetails: any;
  browse: string = AppConstants.COMMON_BUTTON_LABELS.BROWSE

  addprogressBar() {
    if (this.page === 'emotiontourCreate') {
      this.progressTimeInterval = 5000;
    }
    setTimeout(() => {
      const progressInterval = setInterval(() => {
        this.progress += Math.round(this.eventTotal / 2);
        this.eventTotal /= 2;
        if (this.progress >= 100) {
          this.progress = 100;
          clearInterval(progressInterval);
        } else if (this.progress == 0) {
          this.addprogressBar();
        }
      }, this.progressTimeInterval);
    }, this.progressTimeInterval);
  }

  async fileChange(event: any, isCheckBoxSelected?: boolean) {
    this.showSuccessDailog = false;
    try {
      const file = event.target.files[0];
      const allowedExtensions = ["gpx", "zip", "kml"];
      const fileExtension = file.name.split(".").pop();

      if (this.fileField) {
        this.fileField.nativeElement.value = "";
      }
      event.target.value = null;

      if (!allowedExtensions.includes(fileExtension)) {
        this.showErrorToast(LOCATIONS_CONSTANTS.TOAST_ERROR_MSGS.WRONG_FILE_UPLOADED_ERR);
        return;
      }
      this.uploadedFrom = window.location.pathname
      file.uploadedFrom = (this.uploadedFrom.includes('offroad-park') || this.uploadedFrom.includes('offroad-trail')) ? 'OFFROAD_TRACKS' : (this.uploadedFrom.includes('business-tour')) ? 'EMOTION_TOURS' : 'RACE_TRACKS'
      this.trackType = this._actRoute.snapshot.params['trackType'];
      this.hideHeadersConditionally = !['offroad-trail', 'business-tour'].includes(this.trackType);
      this.isShowModal = true;
      this.showProgress = true;
      this.progress = 0;

      this.addprogressBar();
      await this.uploadGpxFile(file, isCheckBoxSelected);
    } catch (error: any) {
      console.error("File change error:", error);
      this.showErrorToast(error);
    }
  }

  private showErrorToast(message: string) {
    if (typeof message !== 'string') {
      message = AppConstants.COMMON_ERROR_MSGS.SOMETHING_WENT_WRONG_MSG;
    }
    this.toastService.show(ToastType.Error, message, '8%', '45%');
    setTimeout(() => {
      this.toastService.hide();
      if (this.fileField && this.fileField.nativeElement) {
        this.fileField.nativeElement.value = null;
      }
    }, LOCATIONS_CONSTANTS.MIN_TIME);
  }

  hideModal() {
    this.progress = 0;
    this.showProgress = false;
    this.closeModal.emit({ showModal: false });
  }

  public async uploadGpxFile(file: any, isCheckBoxSelected?: boolean): Promise<void> {
    try {

      const res = await firstValueFrom(this.locationsHttpService.uploadTrack(file, this.page === 'EVENTS_CIRCUIT_TRACK_UPLOAD', file.uploadedFrom, isCheckBoxSelected));
      const data = res.body;

      if (data?.guid) {
        // check if events module
        if (this.page === 'EVENTS_CIRCUIT_TRACK_UPLOAD') {
          this.progress = 0;
          this.eventTotal = 100;
          this.showProgress = false;
          setTimeout(() => {
            this.closeModal.emit({
              showModal: false,
              gpxuploaded: true,
            });
          }, 200);
          this.showSuccessDailog = true;
          this.dataService.updateTrackGuidSignalValue(data.guid);
          return;
        }
        const response = await firstValueFrom(this.locationsHttpService.getTrackDetails(data.guid));
        const trackData = response.body;
        this.trackDetails = { ...trackData, guid: data.guid };

        this.locationsHttpService.getLatestTrackDetails(this.trackDetails);

        if (this.trackDetails.guid) {
          this.resetvalues(trackData)
        }
      }
    } catch (error) {
      console.error("Upload GPX file error:", error);
      this.handleUploadError(error);
    }
  }

  public resetvalues(trackData: any) {
    this.showProgress = false;
    this.showSuccessDailog = true;

    setTimeout(() => {
      this.closeModal.emit({
        showModal: false,
        gpxuploaded: true,
        uploadedguid: trackData.guid,
        uploadedName: trackData.name,
        trackLength: trackData.trackLength,
      });
      if (this.page === 'emotiontourCreate' || this.page === 'OFFROAD_TRACK_FLOW') {
        console.log('trackData', trackData);
      }
      else if (this.page === 'OFFROAD_PARK') {
        this.openTrackModal.emit(trackData);
        console.log('trackData', trackData);
        this.showProgress = false;
        this.isShowModal = false;

      }
      else {
        this.circuitListService.trackLayoutAction.next(TrackLayoutAction.New);
        this.router.navigateByUrl(`locations/circuit/${trackData.circuitGuid}/layout/${trackData.guid}`);
      }
    }, 200);
  }

  private handleUploadError(error: any): void {
    this.progress = 0;
    this.eventTotal = 100;
    this.showProgress = false;
    this.isShowModal = false;
    this.hideModal();
    if (this.fileField && this.fileField.nativeElement) {
      this.fileField.nativeElement.value = null;
    }

    const errorMsg = this._circuitService.getToastErrMessagesBasedOnCode(error);

    this.showErrorToast(errorMsg);
  }
}